__turbopack_context__.v({
  "brokerage-legal-name": "style-module-scss-module__-e2Fuq__brokerage-legal-name",
  "component": "style-module-scss-module__-e2Fuq__component",
  "country-flag": "style-module-scss-module__-e2Fuq__country-flag",
  "country-flag-image": "style-module-scss-module__-e2Fuq__country-flag-image",
  "country-name": "style-module-scss-module__-e2Fuq__country-name",
  "custom-menu-trigger": "style-module-scss-module__-e2Fuq__custom-menu-trigger",
  "custom-user-trigger": "style-module-scss-module__-e2Fuq__custom-user-trigger",
  "dropdown-arrow-icon": "style-module-scss-module__-e2Fuq__dropdown-arrow-icon",
  "expanded": "style-module-scss-module__-e2Fuq__expanded",
  "full-screen-search": "style-module-scss-module__-e2Fuq__full-screen-search",
  "header-icon": "style-module-scss-module__-e2Fuq__header-icon",
  "layout-container": "style-module-scss-module__-e2Fuq__layout-container",
  "light-theme": "style-module-scss-module__-e2Fuq__light-theme",
  "logo": "style-module-scss-module__-e2Fuq__logo",
  "logo-with-caption": "style-module-scss-module__-e2Fuq__logo-with-caption",
  "menu": "style-module-scss-module__-e2Fuq__menu",
  "mobile-right": "style-module-scss-module__-e2Fuq__mobile-right",
  "nav-btn": "style-module-scss-module__-e2Fuq__nav-btn",
  "navigation": "style-module-scss-module__-e2Fuq__navigation",
  "noHoverNavButton": "style-module-scss-module__-e2Fuq__noHoverNavButton",
  "panel": "style-module-scss-module__-e2Fuq__panel",
  "search": "style-module-scss-module__-e2Fuq__search",
  "search-icon": "style-module-scss-module__-e2Fuq__search-icon",
  "search-icon-mobile": "style-module-scss-module__-e2Fuq__search-icon-mobile",
  "unclickable": "style-module-scss-module__-e2Fuq__unclickable",
  "user-section-wrapper": "style-module-scss-module__-e2Fuq__user-section-wrapper",
  "zoocasa-search-button": "style-module-scss-module__-e2Fuq__zoocasa-search-button",
  "zoocasa-search-button-mobile": "style-module-scss-module__-e2Fuq__zoocasa-search-button-mobile",
});
